import { JsonClassSerializerOptions } from '@sumbricht/json-class-serializer'

export const circularDependencyReferencePropertyName = '$ref'
export const circularDependencyLevelPropertyName = '$level'
export const commonJsonMapperOptions: Partial<JsonClassSerializerOptions> = {
	prettyPrint: false,
	serializationPropertyName: '__type',
	deserializationClassResolver: (obj) => obj?.__type || obj?.['#type'],
	circularDependencyReferencePropertyName,
	circularDependencyLevelPropertyName,
}
